/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AssetType } from '../models/asset-type';
import { InfoFieldWrapper } from '../models/info-field-wrapper';

/**
 * Information Fields Controller
 */
@Injectable({
  providedIn: 'root',
})
class InformationFieldsControllerService extends __BaseService {
  static readonly assetTypesUsingGETPath = '/informationsfields/assetTypes';
  static readonly assetTypesForRequestUsingGETPath = '/informationsfields/assetTypes/{requestId}';
  static readonly getFolderUsingGETPath = '/informationsfields/node/{id}';
  static readonly optionsByInfoFieldUsingGETPath = '/informationsfields/values/{infoFieldId}';
  static readonly optionsByInfoFieldForRequestUsingGETPath = '/informationsfields/values/{infoFieldId}/{requestId}';
  static readonly infoFieldsByAssetTypeUsingGETPath = '/informationsfields/{assetTypeId}';
  static readonly infoFieldsByAssetTypeForRequestUsingGETPath = '/informationsfields/{assetTypeId}/{requestId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * retrieve all asset types
   * @return OK
   */
  assetTypesUsingGETResponse(): __Observable<__StrictHttpResponse<Array<AssetType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/assetTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AssetType>>;
      })
    );
  }

  /**
   * retrieve all metadata languages
   * @return OK
   */
  languagesUsingGETResponse(locale: string): __Observable<__StrictHttpResponse<Map<String, any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/languages/${encodeURIComponent(locale)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Map<String, any>>;
      })
    );
  }

  /**
   * retrieve all asset types
   * @return OK
   */
  languagesUsingGET(locale: string): __Observable<Map<String, any>> {
    return this.languagesUsingGETResponse(locale).pipe(
      __map(_r => _r.body as Map<String, any>)
    );
  }

  /**
   * retrieve all asset types
   * @return OK
   */
  assetTypesUsingGET(): __Observable<Array<AssetType>> {
    return this.assetTypesUsingGETResponse().pipe(
      __map(_r => _r.body as Array<AssetType>)
    );
  }

  /**
   * retrieve all asset types for a specific request
   * @param requestId requestId
   * @return OK
   */
  assetTypesForRequestUsingGETResponse(requestId: string): __Observable<__StrictHttpResponse<Array<AssetType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/assetTypes/${encodeURIComponent(requestId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AssetType>>;
      })
    );
  }
  /**
   * retrieve all asset types for a specific request
   * @param requestId requestId
   * @return OK
   */
  assetTypesForRequestUsingGET(requestId: string): __Observable<Array<AssetType>> {
    return this.assetTypesForRequestUsingGETResponse(requestId).pipe(
      __map(_r => _r.body as Array<AssetType>)
    );
  }

  /**
   * retrieve all child nodes of a specific node
   * @param id id
   * @return OK
   */
  getFolderUsingGETResponse(id: string): __Observable<__StrictHttpResponse<Array<{}>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/node/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<{}>>;
      })
    );
  }
  /**
   * retrieve all child nodes of a specific node
   * @param id id
   * @return OK
   */
  getFolderUsingGET(id: string): __Observable<Array<{}>> {
    return this.getFolderUsingGETResponse(id).pipe(
      __map(_r => _r.body as Array<{}>)
    );
  }

  /**
   * retrieve all possible values for a specific information field
   * @param infoFieldId infoFieldId
   * @return OK
   */
  optionsByInfoFieldUsingGETResponse(infoFieldId: number): __Observable<__StrictHttpResponse<Array<{}>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/values/${encodeURIComponent(infoFieldId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<{}>>;
      })
    );
  }
  /**
   * retrieve all possible values for a specific information field
   * @param infoFieldId infoFieldId
   * @return OK
   */
  optionsByInfoFieldUsingGET(infoFieldId: number): __Observable<Array<{}>> {
    return this.optionsByInfoFieldUsingGETResponse(infoFieldId).pipe(
      __map(_r => _r.body as Array<{}>)
    );
  }

  /**
   * retrieve all possible values for a specific information field
   * @param requestId requestId
   * @param infoFieldId infoFieldId
   * @return OK
   */
  optionsByInfoFieldForRequestUsingGETResponse(requestId: string,
    infoFieldId: number): __Observable<__StrictHttpResponse<Array<{}>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/values/${encodeURIComponent(infoFieldId)}/${encodeURIComponent(requestId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<{}>>;
      })
    );
  }
  /**
   * retrieve all possible values for a specific information field
   * @param requestId requestId
   * @param infoFieldId infoFieldId
   * @return OK
   */
  optionsByInfoFieldForRequestUsingGET(requestId: string,
    infoFieldId: number): __Observable<Array<{}>> {
    return this.optionsByInfoFieldForRequestUsingGETResponse(requestId, infoFieldId).pipe(
      __map(_r => _r.body as Array<{}>)
    );
  }

  /**
   * retrieve all information fields of a specific asset type
   * @param assetTypeId assetTypeId
   * @return OK
   */
  infoFieldsByAssetTypeUsingGETResponse(assetTypeId: number): __Observable<__StrictHttpResponse<{[key: string]: InfoFieldWrapper}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/${encodeURIComponent(assetTypeId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: InfoFieldWrapper}>;
      })
    );
  }

  /**
   * retrieve all fieldSets of a specific asset type
   * @param assetTypeId assetTypeId
   * @return OK
   */
  fieldSetsByAssetTypeUsingGETResponse(assetTypeId: number): __Observable<__StrictHttpResponse<{[key: string]: any}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/fieldsets/${encodeURIComponent(assetTypeId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: any}>;
      })
    );
  }

  /**
   * retrieve all fieldSets of a specific asset type
   * @param assetTypeId assetTypeId
   * @return OK
   */
  fieldSetsByAssetTypeUsingGET(assetTypeId: number): __Observable<{[key: string]: any}> {
    return this.fieldSetsByAssetTypeUsingGETResponse(assetTypeId).pipe(
      __map(_r => _r.body as {[key: string]: any})
    );
  }

  /**
   * retrieve all information fields of a specific asset type
   * @param assetTypeId assetTypeId
   * @return OK
   */
  infoFieldsByAssetTypeUsingGET(assetTypeId: number): __Observable<{[key: string]: InfoFieldWrapper}> {
    return this.infoFieldsByAssetTypeUsingGETResponse(assetTypeId).pipe(
      __map(_r => _r.body as {[key: string]: InfoFieldWrapper})
    );
  }

  /**
   * retrieve all information fields of a specific asset type for a specific request
   * @param requestId requestId
   * @param assetTypeId assetTypeId
   * @return OK
   */
  infoFieldsByAssetTypeForRequestUsingGETResponse(requestId: string,
    assetTypeId: number): __Observable<__StrictHttpResponse<{[key: string]: InfoFieldWrapper}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/informationsfields/${encodeURIComponent(assetTypeId)}/${encodeURIComponent(requestId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{[key: string]: InfoFieldWrapper}>;
      })
    );
  }
  /**
   * retrieve all information fields of a specific asset type for a specific request
   * @param requestId requestId
   * @param assetTypeId assetTypeId
   * @return OK
   */
  infoFieldsByAssetTypeForRequestUsingGET(requestId: string,
    assetTypeId: number): __Observable<{[key: string]: InfoFieldWrapper}> {
    return this.infoFieldsByAssetTypeForRequestUsingGETResponse(requestId, assetTypeId).pipe(
      __map(_r => _r.body as {[key: string]: InfoFieldWrapper})
    );
  }
}

module InformationFieldsControllerService {
}

export { InformationFieldsControllerService }
